import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 sm:px-6 bg-brand-title text-white border-t-4 border-brand-gold text-center" data-id="element-44" data-mp="3udoz2oyozioy">
      <p className="text-sm font-button font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-45" data-mp="c83nzfw9he3f">
        UNE DERNIÈRE OPPORTUNITÉ
      </p>

      <p className="text-base sm:text-lg font-medium mb-6 leading-relaxed max-w-2xl mx-auto text-brand-cream" data-id="element-46" data-mp="m4ovc7vr71af">
        Vos élèves méritent bien plus que des cours improvisés parce que vous
        avez manqué de temps pour les préparer. Ne passez plus des heures chaque
        semaine à créer vos séances et chercher de nouveaux exercices.
        <br data-id="element-47" data-mp="qw6vitpycxuc" />
        <br data-id="element-48" data-mp="qwgl4g7352zi" />
        <span className="font-bold text-white" data-id="element-49" data-mp="qy15jczor5jn">
          Préparez désormais chacun de vos cours avec méthode, confiance et
          professionnalisme. Offrez-vous enfin le système de planification que
          vous auriez aimé posséder dès votre tout premier cours de danse.
        </span>
      </p>

      <div className="bg-white/5 border border-white/10 rounded-xl p-4 mb-6 shadow-lg max-w-sm mx-auto backdrop-blur-sm" data-id="element-50" data-mp="2c712k0ez8tvx">
        <p className="text-sm sm:text-base font-bold mb-1 uppercase tracking-wide text-brand-cream" data-id="element-51" data-mp="2m344p69twsiv">
          💃 DANCE PRO™ — Système 6-en-1 + 5 Bonus
        </p>
        <p className="text-lg line-through opacity-60 mb-1" data-id="element-52" data-mp="2qzufbe2v6vww">97 $</p>
        <p className="text-4xl font-heading font-bold text-brand-gold leading-none" data-id="element-53" data-mp="2v2r3rlf35m8r">
          Aujourd'hui : 27 eur
        </p>
      </div>

      <a href="#pricing" className="block cursor-pointer mb-6" data-id="element-54" data-mp="30093cl77qp43">
        <img src="https://cdn.magicpatterns.com/uploads/6ttQVA2xKvg2v8M78gnpQ7/ChatGPT-Image-8-jul-2026_-07_50_06-p.m..webp" alt="DANCE PRO - Box Set" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-2xl" data-id="element-55" data-mp="34un658o7fyis" />
      </a>

      <div className="mb-4" data-id="element-56" data-mp="3isbpud6jczm9">
        <CTAButton href="#pricing" className="!bg-brand-gold !text-brand-title border-none shadow-[0_4px_14px_0_rgba(200,163,90,0.39)] hover:shadow-[0_6px_20px_rgba(200,163,90,0.23)] hover:!bg-brand-gold/90" data-id="element-57" data-mp="3itmqi44opr95">
          🚀 OUI ! JE VEUX MON SYSTÈME DANCE PRO™
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-[11px] sm:text-xs font-bold text-brand-cream/80" data-id="element-58" data-mp="1sirolcnrnwuy">
        <div className="flex items-center gap-1.5" data-id="element-59" data-mp="22e1r01i2u699">
          <Zap className="w-4 h-4 text-brand-gold" data-id="element-60" data-mp="22gxmzkad6kv2" />
          <span data-id="element-61" data-mp="1xeos2idxl8qb">Accès immédiat • Livraison par e-mail</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-62" data-mp="2bf9a3cc0v0ir">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-63" data-mp="2bezmfveg95g8" />
          <span data-id="element-64" data-mp="27ez6g6bpcm72">4,9/5 — Avis vérifiés</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-65" data-mp="27c35080nbfdv">
          <Shield className="w-4 h-4 text-brand-gold" data-id="element-66" data-mp="h29on2kync3k" />
          <span data-id="element-67" data-mp="czwnysl2m4dn">Garantie 7 jours</span>
        </div>
      </div>
    </section>;
}